import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: "Come ricevo il sistema dopo l'acquisto?",
  a: "Immediatamente dopo il pagamento riceverai un'email con il link di accesso diretto a tutti i 7 volumi e i 5 bonus. Accesso garantito entro 5 minuti."
}, {
  q: 'Va bene se sono alle prime armi o è solo per esperte?',
  a: 'Ballet Pronto™ è progettato per insegnanti di tutti i livelli. Che tu abbia appena iniziato a insegnare o che tu abbia anni di esperienza, il sistema si adatta al tuo contesto e alle tue allieve.'
}, {
  q: 'Ho bisogno di attrezzatura costosa?',
  a: 'No. Con una sbarra, uno spazio adeguato e le allieve giuste ti basta. Il sistema include adattamenti per qualsiasi tipo di sala o studio.'
}, {
  q: "I 5 bonus sono inclusi nell'offerta?",
  a: "Sì. I 5 bonus strategici sono inclusi al 100% nell'acquisto di oggi senza alcun costo aggiuntivo."
}, {
  q: 'Funziona anche per classi di adulte che non hanno mai ballato?',
  a: 'Assolutamente sì. Il sistema include programmi specifici per principianti adulte con zero esperienza di danza classica.'
}, {
  q: "Che differenza c'è con i tutorial gratuiti su YouTube?",
  a: 'I tutorial su YouTube sono contenuti sparsi senza struttura né progressione. Ballet Pronto™ è un sistema operativo completo con 7 volumi organizzati, 60+ lezioni pronte, programmi di progressione annuali e strumenti di coaching professionale.'
}, {
  q: 'È un pagamento unico o un abbonamento?',
  a: 'È un pagamento unico di €27. Nessun abbonamento, nessun rinnovo automatico. Paghi una volta e il sistema è tuo per sempre.'
}, {
  q: "C'è una garanzia reale?",
  a: 'Sì. Hai 7 giorni completi per provarlo. Se non sei soddisfatta per qualsiasi motivo, ti rimborsiamo il 100% senza fare domande.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-ballet-50" data-id="element-64">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        <div className="text-center mb-10 md:mb-16" data-id="element-66">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal mb-4 md:mb-6" data-id="element-67">
            DOMANDE FREQUENTI
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-68">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-ballet-100 overflow-hidden transition-all duration-300 hover:border-ballet-200 hover:shadow-sm" data-id="element-69">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-70">
                <span className="text-sm md:text-base font-bold text-charcoal pr-4" data-id="element-71">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-ballet-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-72" />
              </button>

              <AnimatePresence data-id="element-73">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-74">
                    <div className="px-5 pb-4 md:px-6 md:pb-5 text-sm md:text-base text-gray-600 leading-relaxed border-t border-gray-50 pt-3 md:pt-4" data-id="element-75">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}